import React from 'react';

/** @internal */
export var chevronCircleDownIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "10",
  cy: "10",
  r: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 8.5L10 12.5L14 8.5",
  stroke: "white",
  strokeWidth: "1.8"
}));